module.exports = __webpack_public_path__ + "img/emoji_05.151a3332.png";